<div class="filter-drop-down w-100 -mat-select-height-unset -border-bottom-none">
  <mat-form-field appearance="outline">
    <!-- <mat-label>Search</mat-label> -->
    <span class="graph-container filter-menu search-img">
      <img src="../.../../../../assets/images/search-idec.svg" alt="search" class="h-16 img-fluid">
      <input matInput (keyup)="applyFilter($event)" placeholder="{{filterText}}" #input>
    </span>
  </mat-form-field>
</div>